import React, { useState, useEffect } from 'react';
import { Route } from 'react-router-dom';

import Header from './Header';
import Home from './Home';
// import About from './About';
// import Portfolio from './Portfolio';
// import Blog from './Blog';
// import Contact from './Contact';
import Footer from './Footer';

function Layout() {
    const [home, setHome] = useState({});

    useEffect(() => {
        setHome({
            title_one: "Hello, I'm Manish Thakur.",
            title_two: "I can create beautiful web apps for you.",
            icons: [
                {icon: 'icon-desktop', title: 'Web Developement'},
                {icon: 'icon-phone', title: 'Mobile Apps'},
                {icon: 'icon-strategy', title: 'Marketing strategy'}
            ],
            skills: {
                title: "My skills",
                description: "I have the ability to learn new things quickly & accurately. I am Well conversed with Unit testing.",
                design: [
                    {title: 'Web Design', rank: 'col-xs-11'},
                    {title: 'Mobile Design', rank: 'col-xs-10'},
                    {title: 'Logo design', rank: 'col-xs-11'},
                    {title: 'Branding & Identity', rank: 'col-xs-7'}
                ],
                developing: [
                    {title: 'React', rank: 'col-xs-10'},
                    {title: 'Angular', rank: 'col-xs-11'},
                    {title: 'Node js', rank: 'col-xs-9'},
                    {title: 'Javascript / Jquery', rank: 'col-xs-11'},
                    {title: 'PHP & MySQL', rank: 'col-xs-10'}
                ]
            },
            projects: {
                title: "Check out my latest projects",
                description: "It is very hard to choose some projects from a huge list but i tried...",
                list: [
                    {title: 'Journey Connected', description: 'Angular 7, Node.js, MongoDB', image: 'img/project_1.png', link: 'https://journeyconnected.com'},
                    {title: 'Dinner Share', description: 'PHP, MySQL, Codeigniter', image: 'img/project_2.png', link: 'http://ds.technofox.co.in'},
                    {title: 'COVID-19 Tracker', description: 'React, Node.Js', image: 'img/project_3.png', link: 'http://18.220.112.125/COVID-19/'},
                    //{title: 'Styling Jobs', description: 'PHP, MySQL, Codeigniter', image: 'img/project_4.png', link: 'https://stylingjobs.dk'},
                    {title: 'TripGeek', description: 'PHP, MySQL, Live Booking API', image: 'img/project_6.png', link: 'https://www.tripgeek.com/'},
                    {title: 'DIT CRM', description: 'PHP, MySQL, jQuery, Ajax', image: 'img/project_5.png', link: 'https://ditcrm.dk'}
                ]
            },
            story: {
                title: "Here is a little of my story",
                description: "My Journey as a developer started from Sep 2013...",
                list: [
                    {duration: '2013-2015', title: 'PHP Developer at M2Soft Solutions', description: 'Joined as an Intern, Learn & Implement coding logics and become Sr. Developer in 1.5 Years :)', icon: 'icon-map'},
                    {duration: '2015-2017', title: 'Software Engineer at Systango', description: 'The amazing work journey started. Worked on a Product called `Junction`,  Dash App & Many more APIs.', icon: 'icon-video'},
                    {duration: '2017-2019', title: 'Project Manager at 99Degree Info', description: 'Level up my carrier as Project Manager. Deliver projects with client satisfaction like TripGeek, DinnerShare & Many more...', icon: 'icon-trophy'},
                    {duration: '2019', title: 'Freelance', description: 'Its time to implement things that learn so far. Dive deep with Angular, React & Node js.', icon: 'icon-target'}
                ]
            }
        });
    }, []);

    return (
        <React.Fragment>
            <Header />
                <Route path="/" exact component={() => <Home home={home} />} />
                {/* <Route path="/about" exact component={() => <About />} />
                <Route path="/portfolio" exact component={() => <Portfolio />} />
                <Route path="/blog" exact component={() => <Blog />} />
                <Route path="/contact" exact component={() => <Contact />} /> */}
            <Footer />
        </React.Fragment>
    )
}

export default Layout;